import React from "react";

export class Handelaar {
  constructor(mongo_data) {
    this._parse(mongo_data);
    this.fields = [
      this.title,
      this.address,
      this.postal,
      this.place,
      this.description,
      this.mainPlace,
      this.hours,
      this.site,
      this.number,
      this.mail,
      this.lat,
      this.long,
      this.categories,
    ];
  }

  render_raw() {
    let res = (
      <div>
        {this.fields.map((f, i) =>
          f === undefined ? "" : <div key={i}>{f}</div>
        )}
      </div>
    );

    return res;
  }

  containsInAField = (keyword) => {
    let low = keyword.toLowerCase();
    let toSearch = 5;
    for (let i = 0; i < toSearch; i++) {
      let field = this.fields[i];
      if (field === undefined || field === null) continue;
      if (field.toString().toLowerCase().includes(low)) {
        return true;
      }
    }
    return false;
  };

  _parse(resp) {
    if ("naam" in resp) {
      this.title = resp["naam"];
    }
    if ("adres" in resp) {
      this.address = resp["adres"];
    }
    if ("postcode" in resp) {
      this.postal = resp["postcode"];
    }
    if ("gemeente" in resp) {
      this.place = resp["gemeente"];
    }
    if ("categories" in resp) {
      this.categories = resp["categories"];
    } else {
      this.categories = [];
    }
    console.log(this.categories);
    if ("hoofdgemeente" in resp) {
      this.mainPlace = resp["hoofdgemeente"];
    }
    if ("beschrijving" in resp) {
      if (resp["beschrijving"] !== undefined && resp["beschrijving"] !== null) {
        this.description = resp["beschrijving"].toLowerCase();
        this.description =
          this.description.charAt(0).toUpperCase() + this.description.slice(1);
      } else {
        this.description = undefined;
      }
    }
    if ("site" in resp) {
      this.site = resp["site"];
    }
    if ("openingsuren" in resp) {
      this.hours = resp["openingsuren"];
    }
    if ("nummer" in resp) {
      this.number = resp["nummer"];
    }
    if ("email" in resp) {
      this.mail = resp["email"];
    }
    if ("latitude" in resp && resp["latitude"] !== "") {
      this.lat = parseFloat(resp["latitude"]);
    } else {
      this.lat = 0;
    }
    if ("longitude" in resp && resp["longitude"] !== "") {
      this.long = parseFloat(resp["longitude"]);
    } else {
      this.long = 0;
    }
  }
}
